import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ROUTES, insertIdtoUrl } from 'constants/Routes';

const retrieveLink = (id, title) => {
  switch (title) {
    case 'Issued Rewards':
      return insertIdtoUrl(ROUTES.REWARD_ISSUED, id);
    case 'Trials Ending':
      return insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id);
    case 'Survey Participants':
      return insertIdtoUrl(ROUTES.REPORT_LIST, id);
    case 'Active Surveys':
      return insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, id)
    default:
      return '';
  }
};

const ListItem = ({ value, rank, title, id, listTitle }) => (
  <li key={rank} className="list-group-item">
    <div className="list-link">
      <Link to={retrieveLink(id, listTitle)}>{title}</Link>
    </div>
    <div className="list-number">{value}</div>
  </li>
);

ListItem.defaultProps = {
  rank: 0,
  value: 0,
  title: '',
};

ListItem.propTypes = {
  rank: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  title: PropTypes.string,
  id: PropTypes.number.isRequired,
  listTitle: PropTypes.string.isRequired
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/ListItem.js